export default __webpack_public_path__ + "static/media/call.114cf548.svg";